import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { prodAPI } from '../../../env';

export interface StreamEvent {
  title: string;
  category_name: string;
  category_icon: string;
  datetime: string; // ISO string format
}

export interface StreamEventResponse {
  stream_events: StreamEvent[];
}

@Injectable({
  providedIn: 'root'
})
export class StreamEventService {
  private apiUrl = `${prodAPI}/api/overlay/stream-schedule`;
  private http = inject(HttpClient);

  getNearestStreamEvent(): Observable<StreamEvent | null> {
    return this.http.get<StreamEvent[]>(this.apiUrl).pipe(
      map(response => {
        if (!response?.length) {
          return null;
        }

        const now = new Date();
        const futureEvents = response
          .map(event => ({
            ...event,
            startDate: new Date(event.datetime)
          }))
          .filter(event => event.startDate > now)
          .sort((a, b) => a.startDate.getTime() - b.startDate.getTime());

        return  futureEvents[0] ||  null;
      }),
      catchError(error => {
        console.error('Error loading stream events:', error);
        return of(null);
      })
    );
  }

  getTestStreamEvent(): Observable<StreamEvent | null> {
  // ВРЕМЕННО: для тестирования
    const testEvent: StreamEvent = {
        title: "Liquania's got talent the kimba uprising",
        category_name: "Music Show",
        category_icon: "🎵",
        datetime: new Date(Date.now() + 5100).toISOString() // Через 2 минуты
    };
    console.log(testEvent)
    return of(testEvent);
    }
}
